/**
 * Scene.js — Three.js 场景管理
 * 负责3D场景的创建、管理和销毁
 */

import { initUmbrella3D } from '../components/Umbrella3D.js';

/**
 * 初始化场景
 * @param {HTMLElement} container
 * @param {Object} data
 * @returns {Object} 场景实例
 */
export function initScene(container, data) {
  return initUmbrella3D(container, data);
}

/**
 * 销毁场景
 * @param {Object} sceneInstance
 */
export function disposeScene(sceneInstance) {
  if (sceneInstance && sceneInstance.dispose) {
    sceneInstance.dispose();
  }
}
